import { Button, Flex, scale, Text } from "@capioweb/ui-components"
import React from "react"
import styled from "styled-components"
import { StringProperty } from "../../../@types/EpiFoundationSpa/Property"
import { AppContext, LocalesContext } from "../../../context"
import { sendDeleteAccountDataLayerPush } from "../../../utils"
import { BlockCommonLayout } from "../../../utils/layout"
import { onRemoveAccountClick } from "./api"

const StyledContainer = styled(Flex)`
	border-radius: ${scale.px(5)};
`

interface MyPagesRemoveAccountBlockProps {
	header: StringProperty
	preamble?: StringProperty
}

export const MyPagesRemoveAccountBlock: React.FC<MyPagesRemoveAccountBlockProps> =
	(props) => {
		const { translate, translationKeys } = React.useContext(LocalesContext)
		const appContext = React.useContext(AppContext)
		const [showConfirmation, setShowConfirmation] = React.useState(false)

		return (
			<BlockCommonLayout>
				<StyledContainer
					flexDirection={"column"}
					alignItems={"center"}
					p={{ _: 3, m: 5 }}
					w={1}
					border
				>
					<Flex
						w={1}
						flexDirection="column"
						alignItems={{ _: "center", m: "flex-start" }}
					>
						<Text variant={"headline-2"} textAlign={{ _: "center", m: "left" }}>
							{props.header.value}
						</Text>
						{props.preamble?.value && (
							<Text
								variant={"paragraph-16"}
								textAlign={{ _: "center", m: "left" }}
							>
								{props.preamble?.value}
							</Text>
						)}
						<Flex flexDirection="column" pt={2}>
							<Button
								w={{ _: 1, m: "auto" }}
								onClick={(e) => {
									e.preventDefault()
									setShowConfirmation(true)
								}}
								variant={"white"}
								aria-hidden={!showConfirmation ? "false" : "true"}
								display={!showConfirmation ? "block" : "none"}
							>
								{translate(translationKeys.remove)}
							</Button>
							<Flex
								flexDirection="column"
								w={{ _: 1, m: "auto" }}
								display={showConfirmation ? "block" : "none"}
								aria-hidden={!showConfirmation ? "true" : "false"}
							>
								<Text
									fontWeight="bold"
									fontSize={2.5}
									lineHeight={3.5}
									textAlign={{ _: "center", m: "left" }}
								>
									{translate(translationKeys.removeAccountConfirmationQuery)}
								</Text>
								<Flex
									w={{ _: 1, m: "auto" }}
									flexDirection={{ _: "column", m: "row" }}
								>
									<Button
										onClick={() => {
											if (appContext?.userId) {
												sendDeleteAccountDataLayerPush(appContext.userId)
											}
											onRemoveAccountClick()
										}}
										mr={{ _: 0, m: 2 }}
										mb={{ _: 2, m: 0 }}
									>
										{translate(translationKeys.remove)}
									</Button>
									<Button
										onClick={() => setShowConfirmation(false)}
										variant={"white"}
									>
										{translate(translationKeys.abort)}
									</Button>
								</Flex>
							</Flex>
						</Flex>
					</Flex>
				</StyledContainer>
			</BlockCommonLayout>
		)
	}
